var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"dd-m-banner dd-m-banner--headline"},[_c('h2',[_vm._v(_vm._s(_vm.getTranslateString('Discover your ideal fragrance instantly')))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-635ae66c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/site/js/components/banners/banner-headline.vue
// module id = 566
// module chunks = 3